// extracted by mini-css-extract-plugin
export default {"grid":"Grid_grid__1KVID","fixed":"Grid_fixed__NwNV7","auto":"Grid_auto__NECJL","grid-item":"Grid_grid-item__kHC7z","fullWidth":"Grid_fullWidth__D1bYM"};